import {SortedBy} from '../../models/sorted-by';

export const selectedSortedByParser = <T extends string>(sortOrderRouteParam: T): SortedBy | undefined => {
	if (sortOrderRouteParam) {
		const [value, order] = sortOrderRouteParam.split(',');
		const valueParsed = parseInt(value, 10);

		if (value && order && !Number.isNaN(valueParsed) && (order === 'ascending' || order === 'descending')) {
			return new SortedBy(valueParsed, order);
		} else {
			return undefined;
		}
	} else {
		return undefined;
	}
}


